import React from "react";

import { animateSection } from "../utils/animateSection";

import { data } from "../data/projects.js";
const projects = data.projects;

function Projects() {
  return (
    <section
      id="projects"
      className="py-[40px] sm:py-[60px] max-w-[1000px] text-white/25 flex flex-col justify-center   mx-auto font-sfMonoRegular overflow-x-hidden"
    >
      <div className="about-heading w-fit flex flex-row  mt-[10px] mb-[40px] ">
        <div className="text-theme-green flex items-center text-[15px] sm:text-[20px]">
          04.{" "}
        </div>
        <h1 className="text-theme-gray-light  min-w-fit ml-[10px] text-[26px] sm:text-[32px]  flex justify-center items-center font-calibreSemiBold fontFix">
          Some things I've built
        </h1>
      </div>

      {projects.map((project, index) => (
        <div
          key={index}
          className={`project-box flex flex-col sm:flex-row ${
            index % 2 !== 0 ? "sm:flex-row-reverse" : "sm:flex-row"
          } items-center justify-between w-full min-h-full text-[20px] font-calibreRegular text-theme-gray-deep font-medium mb-[40px] sm:mb-[100px] gap-8`}
        >
          {/* Image Section */}
          <div className="w-full sm:w-1/2">
            <a
              href={project.website}
              target="_blank"
              rel="noreferrer"
              className="block overflow-hidden rounded-md shadow-lg"
            >
              <img
                src={project.img}
                alt={project.title}
                className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
              />
            </a>
          </div>

          {/* Text Section */}
          <div className="w-full sm:w-1/2 flex flex-col justify-center text-center sm:text-left">
            <div className="text-theme-green my-2 font-sfMonoRegular text-[13px]">
              Featured Project
            </div>
            <a
              href={project.website}
              target="_blank"
              rel="noreferrer"
              className="font-calibreSemiBold text-[28px] text-theme-gray-light mb-5 hover:text-theme-green cursor-pointer"
            >
              {project.title}
            </a>
            <div className="sm:p-6 sm:bg-theme-light-navy rounded text-theme-light-slate z-10 text-[18px] sm:text-[20px]">
              <p>{project.description}</p>
            </div>

            {/* Tech stack */}
            <div className="flex flex-wrap mt-4 gap-4 text-[13px] font-sfMonoRegular text-theme-lightest-slate">
              {project.technologies.map((technology, i) => (
                <span key={i}>{technology}</span>
              ))}
            </div>

            {/* Links */}
            <div className="flex flex-row items-center gap-4 mt-4">
              {project.github && (
                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  className="w-[40px] h-[40px] p-[10px]"
                >
                  {/* GitHub Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-full h-full"
                  >
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.25 3.438 9.688 8.205 11.285.6.111.82-.261.82-.577 0-.287-.011-1.243-.017-2.25-3.338.724-4.042-1.607-4.042-1.607-.546-1.384-1.333-1.754-1.333-1.754-1.089-.743.083-.728.083-.728 1.205.085 1.838 1.237 1.838 1.237 1.07 1.832 2.805 1.303 3.49.996.108-.775.419-1.303.763-1.603-2.665-.303-5.467-1.333-5.467-5.933 0-1.313.469-2.386 1.236-3.22-.124-.303-.536-1.53.117-3.185 0 0 1.008-.323 3.301 1.23.957-.266 1.986-.399 3.006-.404 1.02.005 2.049.138 3.006.404 2.293-1.553 3.301-1.23 3.301-1.23.653 1.655.241 2.882.118 3.185.768.834 1.236 1.907 1.236 3.22 0 4.607-2.805 5.63-5.475 5.93.43.371.815 1.102.815 2.222 0 1.606-.014 2.91-.017 3.303 0 .318.218.693.825.577C20.563 21.688 24 17.25 24 12c0-6.627-5.373-12-12-12z" />
                  </svg>
                </a>
              )}
              {project.yt && (
                <a
                  href={project.yt}
                  target="_blank"
                  rel="noreferrer"
                  className="w-[40px] h-[40px] p-[10px]"
                >
                  {/* presentation Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <rect
                      x="5"
                      y="5"
                      width="12"
                      height="9"
                      rx="2"
                      opacity="0.35"
                    />
                    <rect x="7" y="8" width="12" height="9" rx="2" />
                    <rect x="9" y="10" width="8" height="1.5" rx="0.5" />
                    <rect x="9" y="12.5" width="5" height="1.5" rx="0.5" />
                  </svg>
                </a>
              )}
              {project.website && (
                <a
                  href={project.website}
                  target="_blank"
                  rel="noreferrer"
                  className="w-[40px] h-[40px] p-[10px]"
                >
                  {/* External Link Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                    <polyline points="15 3 21 3 21 9" />
                    <line x1="10" y1="14" x2="21" y2="3" />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

function animatedSection() {
  return animateSection(Projects);
}

export default animatedSection;
